import RegistrationDateBuilderContainer from './RegistrationDateBuilderContainer';

export default RegistrationDateBuilderContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/RegistrationDateBuilder/index.js